import React, { useEffect, useState } from "react";
import classes from "./StudentVisa.module.scss";
import CustomImage from "../../CustomImage";

interface StudentVisaProps {
  countryData?: any;
}

const StudentVisa: React.FC<StudentVisaProps> = ({ countryData }) => {
  const [remainingDocCount, setRemainingDocCount] = useState(0);
  const studentVisaData = countryData?.studentVisa ?? [];

  useEffect(() => {
    if (studentVisaData?.visaDocuments?.length > 0) {
      setRemainingDocCount(countryData?.studentVisa?.visaDocuments?.length - 3);
    }
  }, [countryData]);

  const onCtaClick = (link: string) => () => {
    window.open(link, "_blank");
  };

  return (
    <section id="visa" className={classes["sv-section"]}>
      <div className={classes["sv-container"]}>
        <h2 className={classes["sv-heading"]}>{countryData?.studentVisa?.title ?? ""}</h2>
        <div className={classes["sv-subtext"]} dangerouslySetInnerHTML={{ __html: studentVisaData?.description ?? "" }}></div>

        <div className={classes["sv-stats"]}>
          {studentVisaData?.statCard?.map((stat: any) => (
            <div key={stat.id} className={classes["sv-stat-card"]}>
              <span className={classes["sv-stat-card__value"]}>{stat.value ?? ""}</span>
              <span className={classes["sv-stat-card__label"]}>{stat.title ?? ""}</span>
            </div>
          ))}
        </div>

        <div className={classes["sv-bottom"]}>
          <div className={classes["sv-docs"]}>
            <h3 className={classes["sv-docs__title"]}>Documents Required for Visa Application</h3>
            <div className={classes["sv-docs__grid"]}>
              {studentVisaData?.visaDocuments?.length > 0 &&
                studentVisaData?.visaDocuments?.map((doc: any) => (
                  <div key={doc.id} className={classes["sv-docs__item"]}>
                    <div className={classes["sv-docs__item__icon"]}>
                      <CustomImage src="/icons/double_tickmark.svg" alt="check" width={14} height={6} objectFit="cover" />
                    </div>
                    <span>{doc?.document ?? ""}</span>
                  </div>
                ))}
              {/* {remainingDocCount > 0 && <div className={classes["sv-docs__more"]}>+ {remainingDocCount} more documents</div>} */}
            </div>
          </div>

          {studentVisaData?.cardTitle && (
            <div className={classes["sv-cta"]}>
              <div className={classes["sv-cta__title"]} dangerouslySetInnerHTML={{ __html: studentVisaData?.cardTitle ?? "" }}></div>
              <div className={classes["sv-cta__actions"]}>
                <span className={classes["sv-cta__desc"]}>{studentVisaData?.cardDescription ?? ""}</span>
                <button className={classes["sv-cta__button"]} onClick={onCtaClick(studentVisaData.btnLink)}>
                  {studentVisaData?.btnText ?? "Guide As PDF"}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default StudentVisa;
